import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';

import ContentWrapper from 'components/ContentWrapper/ContentWrapper';
import useGetPaymentDetails from 'hooks/useGetPaymentDetails';
import { t } from 'locales/i18n';
import NoPaymentInfo from 'pages/Payment/NoPaymentInfo';
import PaymentInfo from 'pages/Payment/PaymentInfo';

const Payment = () => {
  const { interviewUid = '' } = useParams();
  const { data: paymentDetails, isLoading } =
    useGetPaymentDetails(interviewUid);

  return (
    <ContentWrapper title={t('Payment')}>
      {isLoading ? (
        <Skeleton height={200} />
      ) : (
        <div>
          {paymentDetails ? (
            <PaymentInfo details={paymentDetails} />
          ) : (
            <NoPaymentInfo />
          )}
        </div>
      )}
    </ContentWrapper>
  );
};

export default Payment;
